// extracted by mini-css-extract-plugin
module.exports = {"cardLink":"Home_cardLink_2CX4J","card":"Home_card_1ylVo"};